import {fetchPost} from "../../requests/NetworkRequestAuth0";
import {uri} from "./AppRequest";

export const createPaymentIntent = (
    venueId,
    packageId,
    successMethod,
    errorMethod,
    getAccessToken
) => {
    const params = {
        venueId: venueId,
        packageId: packageId
    };
    fetchPost(
        uri + "/user/payment/intent",
        successMethod,
        errorMethod,
        params,
        getAccessToken);
};